import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import { objToParams, objToParamsContinuation } from "../../utils/func";

const initialState = {
  loading: false,
  error: null,
  memberPayHistory: [],
  approvalReport: [],
  memberUpgradeReport: [],
  memberReport: [],
  memberDetails: null,
  birthdayReport: [],
  inductionReport: [],
  examCenterReport: [],
  examApplicantReport: [],
  memberDuesReport: [],
  examResultListing: [],
  memberOutstandingDuesReport: [],
  paymentType: [],
  transactionLogReport: [],
  reportsParams:{
    page: 1,
    pageSize: 10,
  },
};

export const fetchMemberPayHistory = createAsyncThunk(
  "report2/fetchMemberPayHistory",
  async (arg, {getState}) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/member-payment-history${objToParams(getState()?.report2?.reportsParams)}`
    );
  }
);

export const fetchApprovalReport = createAsyncThunk(
  "report2/fetchApprovalReport",
  async ({ startDate, endDate, approvalReportCategory }, {getState}) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/approval?startDate=${startDate}&endDate=${endDate}&approvalReportCategory=${approvalReportCategory}${objToParamsContinuation(getState()?.report2?.reportsParams)}`
    );
  }
);

export const fetchMemberUpgradeReport = createAsyncThunk(
  "report2/fetchMemberUpgradeReport",
  async ({ startDate, endDate }, {getState}) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/member-upgrade-report?StartDate=${startDate}&EndDate=${endDate}${objToParamsContinuation(getState()?.report2?.reportsParams)}`
    );
  }
);

export const fetchMemberReport = createAsyncThunk(
  "report2/fetchMemberReport",
  async ({ MembershipCategory, startDate, endDate }, {getState}) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/member?MembershipCategory=${MembershipCategory}&StartDate=${startDate}&EndDate=${endDate}${objToParamsContinuation(getState()?.report2?.reportsParams)}`
    );
  }
);

export const fetchMemberDetails = createAsyncThunk(
  "report2/fetchMemberDetails",
  async (memberNumber, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Report/member-details`,
        "post",
        memberNumber
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchBirthdayReport = createAsyncThunk(
  "report2/fetchbirthdayreport",
  async () => {
    return httpRequest(`${BASE_URL}/v2/Report/birthday?PageSize=1000`);
  }
);

export const fetchInductionReport = createAsyncThunk(
  "report2/fetchinductionreport",
  async (arg, {getState}) => {
    return httpRequest(`${BASE_URL}/v2/Report/induction${objToParams(getState()?.report2?.reportsParams)}`);
  }
);

export const fetchExamCentreReport = createAsyncThunk(
  "report2/fetchexamcentrereport",
  async (arg, {getState}) => {
    return httpRequest(`${BASE_URL}/v2/Report/exam-centre${objToParams(getState()?.report2?.reportsParams)}`);
  }
);

export const fetchExamApplicantReport = createAsyncThunk(
  "report2/fetchExamApplicantReport",
  async ({ ExamPeriodId, ExamCentreId, startDate, endDate }) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/exam-applicant?PageSize=1000&ExamPeriodId=${ExamPeriodId}&ExamCentreId=${ExamCentreId}&StartDate=${startDate}&EndDate=${endDate}`
    );
  }
);

export const fetchExamListingReport = createAsyncThunk(
  "report2/fetchExamListingReport",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Report/exam-result-listing?Page=1&PageSize=1000`,
        "post",
        arg
      );

      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchPaymentTypeReport = createAsyncThunk(
  "report2/fetchPaymentTypeReport",
  async ({feeType, startDate, endDate }, {getState}) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/payment-type-report?feeType=${feeType}&StartDate=${startDate}&EndDate=${endDate}${objToParamsContinuation(getState()?.report2?.reportsParams)}`
    );
  }
);

export const fetchMemberDuesReport = createAsyncThunk(
  "report2/fetchMemberDuesReport",
  async ({ membershipCategory, startDate, endDate }) => {
    return httpRequest(
      `${BASE_URL}/v2/Report/member-dues-management?PageSize=1000&membershipCategory=${membershipCategory}&StartDate=${startDate}&EndDate=${endDate}`
    );
  }
);

export const fetchMemberOutstandingDuesReport = createAsyncThunk(
    "report2/fetchMemberOutstandingDuesReport",
    async ({ startDate, endDate }, {getState}) => {
      return httpRequest(
        `${BASE_URL}/v2/Report/member-outstanding-dues?StartDate=${startDate}&EndDate=${endDate}${objToParamsContinuation(getState()?.report2?.reportsParams)}`
      );
    }
  );
  

export const fetchTransactionLogReport = createAsyncThunk(
  "report2/fetchTransactionLogReport",
  async ({payload, startDate, endDate}, { rejectWithValue, getState }) => {
    
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Report/transaction-log?StartDate=${startDate}&EndDate=${endDate}${objToParamsContinuation(getState()?.report2?.reportsParams)}`,
        "post",
        payload
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const report2Slice = createSlice({
  name: "report2",
  initialState,
  reducers: {
    setUpdateApprovalReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.approvalReport = [];
    },
    setUpdateApprovalReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.approvalReport = [];
    },

    setMemberPayHistoryReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.memberPayHistory = [];
    },
    setMemberPayHistoryReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.memberPayHistory = [];
    },

    setUpdateMemberReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.memberReport = [];
    },
    setUpdateMemberReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.memberReport = [];
    },

    setUpdateMemberUpgradeReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.memberUpgradeReport = [];
    },
    setUpdateMemberUpgradeReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.memberUpgradeReport = [];
    },

    setUpdateExamCenterReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.examCenterReport = [];
    },
    setUpdateExamCenterReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.examCenterReport = [];
    },

    setUpdateInductionReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.inductionReport = [];
    },
    setUpdateInductionReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.inductionReport = [];
    },

    setPaymentTypeReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.paymentType = [];
    },
    setPaymentTypeReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.paymentType = [];
    },

    setTransactionLogReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.transactionLogReport = [];
    },
    setTransactionLogReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.transactionLogReport = [];
    },

    setMemberOutstandingDuesReportPagination:(state, {payload}) => {
      state.reportsParams.page = payload;
      state.memberOutstandingDuesReport = [];
    },
    setMemberOutstandingDuesReportPageSize:(state, {payload}) => {
      state.reportsParams.pageSize = payload;
      state.memberOutstandingDuesReport = [];
    },

   
  },

  extraReducers: (builder) => {
    //get member payment history:
    builder.addCase(fetchMemberPayHistory.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchMemberPayHistory.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.memberPayHistory = payload;
      state.error = payload?.error?.description || null;
    });

    builder.addCase(fetchMemberPayHistory.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //get approval report:
    builder.addCase(fetchApprovalReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchApprovalReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.approvalReport = payload;
      state.error = null;
    });

    builder.addCase(fetchApprovalReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //get member upgrade report:
    builder.addCase(fetchMemberUpgradeReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchMemberUpgradeReport.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.memberUpgradeReport = payload;
        state.error = null;
      }
    );

    builder.addCase(fetchMemberUpgradeReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //get member report:
    builder.addCase(fetchMemberReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchMemberReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.memberReport = payload;
      state.error = null;
    });

    builder.addCase(fetchMemberReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // get birthday report:
    builder.addCase(fetchBirthdayReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchBirthdayReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.birthdayReport = payload;
      state.error = null;
    });

    builder.addCase(fetchBirthdayReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // get induction report:
    builder.addCase(fetchInductionReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchInductionReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.inductionReport = payload;
      state.error = null;
    });

    builder.addCase(fetchInductionReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // get exam centre report:
    builder.addCase(fetchExamCentreReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchExamCentreReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.examCenterReport = payload;
      state.error = null;
    });

    builder.addCase(fetchExamCentreReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //get member details:
    builder.addCase(fetchMemberDetails.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchMemberDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.memberDetails = payload;
      state.error = null;
    });

    builder.addCase(fetchMemberDetails.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // get exam applicant report:
    builder.addCase(fetchExamApplicantReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      fetchExamApplicantReport.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.examApplicantReport = payload;
        state.error = null;
      }
    );

    builder.addCase(fetchExamApplicantReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //get member dues report:
    builder.addCase(fetchMemberDuesReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchMemberDuesReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.memberDuesReport = payload;
      state.error = null;
    });

    builder.addCase(fetchMemberDuesReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

      // get exam listing report 
      builder.addCase(fetchExamListingReport.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(fetchExamListingReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.examResultListing = payload;
        state.error = null;
    });

    builder.addCase(fetchExamListingReport.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
    });

      // get member outstanding dues report:
      builder.addCase(fetchMemberOutstandingDuesReport.pending, (state) => {
        state.loading = true;
      });
  
      builder.addCase(fetchMemberOutstandingDuesReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.memberOutstandingDuesReport = payload;
        state.error = null;
      });
  
      builder.addCase(fetchMemberOutstandingDuesReport.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      });

    //get payment type details:
    builder.addCase(fetchPaymentTypeReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchPaymentTypeReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.paymentType = payload;
      state.error = null;
    });

    builder.addCase(fetchPaymentTypeReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    // fetch TransactionLog Report
    builder.addCase(fetchTransactionLogReport.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchTransactionLogReport.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.transactionLogReport = payload;
      state.error = null;
    });

    builder.addCase(fetchTransactionLogReport.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });
  },
});

export default report2Slice.reducer;
export const {setUpdateApprovalReportPagination, setUpdateApprovalReportPageSize, setUpdateMemberReportPagination, setUpdateMemberReportPageSize,
  setUpdateMemberUpgradeReportPagination, setUpdateMemberUpgradeReportPageSize, setUpdateExamCenterReportPagination, setUpdateExamCenterReportPageSize,
  setUpdateInductionReportPagination, setUpdateInductionReportPageSize, setMemberPayHistoryReportPagination, setMemberPayHistoryReportPageSize,
  setPaymentTypeReportPagination, setPaymentTypeReportPageSize, setTransactionLogReportPagination, setTransactionLogReportPageSize, 
  setMemberOutstandingDuesReportPagination, setMemberOutstandingDuesReportPageSize,

} = report2Slice.actions;
